import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { ContextFamily, ContextTone } from '@quipex/shared/utils';
import { Skeleton } from './skeleton';

@Component({
    selector: 'qpx-skeleton-pill',
    imports: [Skeleton],
    template: `
        <qpx-skeleton
            [context]="context()"
            [tone]="tone()"
            [width]="width()"
            height="1.5rem"
            borderRadius="var(--qpx-radius-lg)"
            [ariaLabel]="ariaLabel()"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'block',
    },
})
export class SkeletonPill {
    //#region Inputs
    public readonly context = input<ContextFamily>();
    public readonly tone = input<ContextTone>();
    public readonly width = input<string | null>(null);
    public readonly ariaLabel = input('');
    //#endregion
}
